import { FC } from "react";

import { SvgLogoEp } from "./assets/svg/svg-logo-ep";
import styles from "./landing-page.module.scss";
import { SvgLogo } from "./svg-logo";

export interface LandingPageProps {}

export const LandingPage: FC<LandingPageProps> = () => {
  return (
    <div className={styles.centered}>
      <SvgLogo className={styles.intractive} />
      <SvgLogoEp className={styles.energyplatform} />
    </div>
  );
};
